import React, { useState } from "react";
import SimpleBar from 'simplebar-react';
import { useLocation } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlug, faUsers, faSignOutAlt, faTimes, faHome, faStepBackward, faPrint, faUserShield } from "@fortawesome/free-solid-svg-icons";
import { Nav, Image, Button, Navbar } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';

import { Routes } from "../routes";
import ReactHero from "../assets/img/technologies/react-hero-logo.svg";
import ProfilePicture from "../assets/img/team/profile-picture-3.jpg";
import SidebarItem from "./sidebar/SidebarItem";

import { countEnabledPermissions } from '../helper/permission'

export default (props = {}) => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const showClass = show ? "show" : "";

  const onCollapse = () => setShow(!show);

  const permission = localStorage.getItem('permission')
  const permissionPoint = countEnabledPermissions(permission || '')

  return (
    <>
      <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none">
        <Navbar.Brand className="me-lg-5" as={Link} to={Routes.Overview.path}>
          <Image src={ReactHero} className="navbar-brand-light" />
        </Navbar.Brand>
        <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`}>
          <div className="sidebar-inner px-4 pt-3">
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">
                  <Image src={ProfilePicture} className="card-img-top rounded-circle border-white" />
                </div>
                <div className="d-block">
                  <h6>Hi, Jane</h6>
                  <Button as={Link} variant="secondary" size="xs" to={Routes.Signin.path} className="text-dark">
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Sign Out
                  </Button>
                </div>
              </div>
              <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            <Nav className="flex-column pt-3 pt-md-0">
              {(permissionPoint > 1) &&
                <SidebarItem title="Quay về" link={Routes.Overview.path} icon={faStepBackward} setShow={setShow} />
              }

              <SidebarItem title="Trang chủ" link={Routes.Overview.path} icon={faHome} setShow={setShow} />

              <SidebarItem title="Thiết bị USB" link={Routes.DeviceManagementDevices.path} icon={faPlug} setShow={setShow} />

              <SidebarItem title="Nhân viên in vé" link={Routes.DeviceManagementEmployees.path} icon={faUsers} setShow={setShow} />

              {(permissionPoint > 1) && (
                <SidebarItem title="Nhân viên (Admin)" link={Routes.DeviceManagementAdmins.path} icon={faUserShield} setShow={setShow} />
              )}

              <SidebarItem title="Hàng đợi in" link={Routes.DeviceManagementPrintQueue.path} icon={faPrint} setShow={setShow} />

            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
